// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgHeatingLevelLowIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      d="M18.14 21c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41c2.09-2.09 2.09-5.49 0-7.59a5.95 5.95 0 0 1 0-8.41.996.996 0 1 1 1.41 1.41 3.92 3.92 0 0 0-1.16 2.79c0 1.05.41 2.05 1.16 2.79A7.32 7.32 0 0 1 21 15.5c0 1.97-.77 3.82-2.16 5.21-.2.2-.45.29-.71.29zm-5.43-.29A6.6 6.6 0 0 0 14.66 16c0-1.78-.69-3.45-1.95-4.71A4.62 4.62 0 0 1 11.35 8c0-1.24.48-2.41 1.36-3.29A.996.996 0 1 0 11.3 3.3a6.6 6.6 0 0 0-1.95 4.71c0 1.78.69 3.45 1.95 4.71.88.88 1.36 2.05 1.36 3.29s-.48 2.41-1.36 3.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29z"
      opacity={0.3}
    />
    <path d="M6.57 20.71a5.95 5.95 0 0 0 0-8.41c-2.09-2.1-2.09-5.5 0-7.59a.996.996 0 0 0 0-1.41.996.996 0 0 0-1.41-.01A7.32 7.32 0 0 0 3 8.5c0 1.97.77 3.82 2.16 5.21a3.92 3.92 0 0 1 1.16 2.79c0 1.05-.41 2.05-1.16 2.79a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29z" />
  </g>
);
export default SvgHeatingLevelLowIcon;
SvgHeatingLevelLowIcon.displayName = 'SvgHeatingLevelLowIcon';
